module.exports = __webpack_public_path__ + "static/img/bg-bottom.17f6387.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bg-bottom.png
// module id = 209
// module chunks = 1